export class ModalRequest {
  constructor() {
    this.init()
  }

  init() {
    document.querySelectorAll('[modal-request]').forEach(modalRequestElement => {
      modalRequestElement.addEventListener('click', () => {
        const popoverTarget = modalRequestElement.getAttribute('popovertarget')
        const modal = document.getElementById(popoverTarget)
        modal.showModal()
        const documentFile = modalRequestElement.getAttribute('data-document-file')
        const productName = modalRequestElement.getAttribute('data-product-name')
        const form = modal.querySelector('form')
        let input = form.querySelector('.document-url input')
        if (input) {
          jQuery(input).val(documentFile)
        }

        input = form.querySelector('.product-name input')
        if (input) {
          jQuery(input).val(productName)
        }
      })
    })
  }
}
